export const FutureTime = "2099-12-31T00:00:00.000Z";
